import React from "react";
import styled from "styled-components";
import { Container, Row, Col } from "react-grid-system";
import { Fade, Slide } from "react-awesome-reveal";
import { BlackBtn } from "../IPWebsiteRedesign/BlackBtn";
import { userTrack } from "../Common";
import "../../components/IPWebsiteRedesign/global.css";
import { OrangeOutlineBtn } from "../IPWebsiteRedesign/OrangeOutlineBtn";
import getConfig from "next/config";

const MainWrapper = styled.section`
  height: 613px;
  background: var(--bg-color-old-lace);
  display: flex;
  justify-content: center;
  align-items: center;
  @media screen and (max-width: 767px) {
    height: 530px;
  }
`;

const Title = styled.h1`
  font-family: Roboto;
  font-size: var(--size45);
  font-weight: var(--fw200);
  line-height: 71px;
  text-align: center;
  color: var(--text-color-black);
  width: 848px;
  margin: 0 auto;
  margin-bottom: 70px;
  @media screen and (max-width: 767px) {
    font-size: var(--size30);
    width: 300px;
    line-height: 51px;
  }
`;

const DualButtonWrapper = styled.div`
  display: flex;
  justify-content: center;
  gap: 25px;
  @media screen and (max-width: 767px) {
    flex-direction: column;
    align-items: center;
  }
`;

export const FinalBanner = () => {
  const { publicRuntimeConfig } = getConfig();


  // const HandleFreeTrail = async () => {
  //   await userTrack("", "Onclick of Get started for free", "Platform");
  //   window.location.href = process.env.NODE_ENV  =="development" ? "/Get-Started":publicRuntimeConfig.assetPrefix+"/Get-Started.html";
  // };


  const HandleFreeTrail = async () => {
    await userTrack("", "Onclick of Schedule a demo", "Platform");
    // Dynamically construct the UTM source
    const pageName = `${window.location.pathname
      .split("/")
      .filter(Boolean)
      .pop()
      .toLowerCase()
      .replace(/\s+/g, "-")}-page`;
    const buttonName = "schedule-demo-button";

  
    const utmSource = `${pageName}-${buttonName}-fuel-growth-cta`;
    const encodedUtmSource = window.btoa(utmSource); // Encode the UTM source

    // Store encoded UTM source in localStorage
    localStorage.setItem("utm-source", encodedUtmSource);
    window.location.href =
      process.env.NODE_ENV == "development"
        ? "/Schedule-Demo"
        : publicRuntimeConfig.assetPrefix + "/Schedule-Demo.html";
  };

  const HandleReqDemo = async () => {
    await userTrack("", "Onclick of contact sales", "Platform");
    window.location.href = process.env.NODE_ENV  =="development" ? "/Contact-Sales":publicRuntimeConfig.assetPrefix+"/Contact-Sales.html";
  };

  return (
    <>
      <MainWrapper>
        <Container>
          <Row>
            <Col xl={12} lg={12} sm={12} xs={12}>
              <Fade duration={1500} fraction={0.5} triggerOnce={true}>
                <Title>
                  Fuel growth and{" "}
                  <span>
                    <b>amplify innovation</b>
                  </span>{" "}
                  with Ideapoke's{" "}
                  <span>
                    <b>AI-Powered</b>
                  </span>{" "}
                  Research Platform!
                </Title>
              </Fade>
            </Col>
            <Col xl={12} lg={12} sm={12} xs={12}>
              <Fade duration={2500} fraction={0.5} triggerOnce={true}>
                <DualButtonWrapper>
                  <BlackBtn
                    onClick={HandleFreeTrail}
                    width="241px"
                    height="56px"
                  >
                    Schedule a demo
                  </BlackBtn>
                  <OrangeOutlineBtn
                    onClick={HandleReqDemo}
                    width="234px"
                    height="56px"
                  >
                    Contact Sales
                  </OrangeOutlineBtn>
                </DualButtonWrapper>
              </Fade>
            </Col>
          </Row>
        </Container>
      </MainWrapper>
    </>
  );
};
